import React, { useEffect, useState } from 'react';

import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import { Can } from '@casl/react';
import { ChipSelect } from 'dsilo-ui-components';

import { Button, CircularProgress, Grid, InputLabel, makeStyles, TextField } from '@material-ui/core';
import { SystemOperations } from '../../utility/AbilityCheck';
import { getOrgId } from '../../utility/utils';

const useStyles = makeStyles((theme) => {
  const isNewV1Theme = theme?.isNewV1Theme || false;
  return {

    chipSelect: {
        '& input': {
            height: 27,
        },
      ...(isNewV1Theme 
            ? {
              '& div[class^="ChipSelect-valueContainer"]': {
                    padding: '8px !important',  
                    gap: 2,
                },
              }
              : {}), 
       ...(isNewV1Theme 
            ? { 
            '& .MuiChip-root': { 
              backgroundColor: '#fff !important',
              border: '1px solid #D5D6DD !important',     
            },   
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#D5D6DD !important',  
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#303F9F !important',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#3F51B5 !important',
            },
          } 
          : {}),   
    },
    label: {
        display: 'flex',
        alignItems: 'center',
    },
    TextField: {
        width: '100%',
        '& .MuiInputBase-formControl': {
            height: '43px !important'
        },
    },
    status: {
        display: 'contents'
    },
    textField: {
          '& .MuiOutlinedInput-input': {
          padding: '14px !important',
          fontSize: '12px',
          },
          '& .MuiOutlinedInput-input:-webkit-autofill': {
          WebkitBoxShadow: '0 0 0 1000px #fff inset !important',
          },
          '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#D5D6DD !important',  
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: '#303F9F !important',
          },

          '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#3F51B5 !important',
          },
    },
    readonlyTextField: {
          '& .MuiOutlinedInput-input': {
          padding: '14px !important',
          fontSize: '12px',
          cursor: 'default',
          },
          '& .MuiOutlinedInput-input:-webkit-autofill': {
          WebkitBoxShadow: '0 0 0 1000px #fff inset !important',
          },
          '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#D5D6DD !important',  
          borderWidth: '1px !important'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: '#D5D6DD !important',
          },
          '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: '#D5D6DD !important',
          },
    },
    gridContainer:{
        border: "1px solid #E0E0E0",
        borderRadius: "4px",
    },
    containerDiv:{
      width: '100% !important', 
      padding: '10px', 
      margin : '0px !important',
    },
    lables:{
        color: '#78798E',
        fontSize: '12px',
        lineHeight: '17px',
        marginBottom:6
    },
    update:{
        borderRadius: "4px",
        border: "1px solid #3F51B5",
        background: "#3F51B5",
        color: '#fff',
        textTransform: 'capitalize',
        height: '30px',
        boxSizing: 'border-box',
        boxShadow: 'none',
        "&:hover": {
            background: "#303F9F",
            color: "#fff",
            boxShadow: 'none',
        },
    },
    cancel:{
       borderRadius: "4px", 
       border: "1px solid #3F51B5",
       color: '#3F51B5',
       background: "#fff",
       textTransform: 'capitalize',
       height: '30px',
       boxSizing: 'border-box',
       boxShadow: 'none',
       "&:hover": {
        boxShadow: 'none',       
       },
    	},
      buttonContainer:{
      borderTop: '1px solid #E0E0E0', 
      padding: 16,
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      gap: 10
    },
}});
const sampleobj = { "firstName": true, "lastName": true, "email": true } // ,"phone": true

const BasicInfo = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const { isNewV1Theme } = props;
    const { chartUniqueId, chartData } = props.data
    const { ability, userHasAbility } = props
    const { CREATE, EDIT } = SystemOperations;

    const [state, setState] = useState({ status: 'Active' })

    useEffect(() => {
        if (props.memberDetails) {
            setState({ ...state, ...props.memberDetails, ...props.fianlFormData })
        }
    }, [props.memberDetails, props.fianlFormData])

    useEffect(() => {
        if (props.formData?.document?.[chartUniqueId + '_create_member']?.message) {
            toast.success(props.formData.document[chartUniqueId + '_create_member'].message);
            props.history.push({ pathname: `/${props.match.params.appid}/page/userManagement/` });
        }
    }, [props.formData?.document?.[chartUniqueId + '_create_member']])

    useEffect(() => {
        if (props.formData?.document?.[chartUniqueId + '_terminate_member']?.message) {
            toast.success(props.formData.document[chartUniqueId + '_terminate_member'].message);
            props.history.push({ pathname: `/${props.match.params.appid}/page/userManagement/` });
        }
    }, [props.formData?.document?.[chartUniqueId + '_terminate_member']])


	const handlesFormInputs = (e) => {
		setState({ ...state, [e.target.name]: e.target.value })
		props.handlesSaveFunctionality({ ...state, [e.target.name]: e.target.value })
		props.validator({ [e.target.name]: e.target.value ? false : true })
	}

	const conditionCheck = (sampleobj) => {
		if (Object.values(sampleobj).every(ele => !ele)) {
			return true
		} else if (Object.values(sampleobj).every(ele => ele)) {
			return true
		} else if (Object.values(sampleobj).some(ele => ele)) {
			return false
		}
	}

    const handlesFinalSubmit = () => {
        if (Object.keys(state).length === 0 || Object.keys(props.validate).length === 0) {
            props.validator({ firstName: true, lastName: true, email: true })
        } else if (Object.keys(props.validate).length === 3 && conditionCheck(props.validate)) {
            let payload = { ...state, ...props.fianlFormData, appId: props.appid }
            if (payload && payload.roles?.length) {
                payload['roles'] = payload.roles.map(item => {
                    return {
                        id: item.value,
                        name: item.label,
                        label: item.label
                    }
                })
            } else {
              payload['roles'] = []
            }
            if (payload && payload.groups?.length) {
                payload['groups'] = payload.groups.map(item => {
                    return {
                        id: item.value,
                        name: item.label,
                        label: item.label
                    }
                })
            } else {
              payload['groups'] = []
            }
            
            if (payload && payload.supervisor?.value) {
                payload['supervisor'] = {
                    id: payload.supervisor.id,
                    name: payload.supervisor.name
                }
            }
            if (payload && !payload?.isDisable) {
                payload['isDisable'] = false;
            }
            console.log("it is payload before users submit", payload)
            props.createMember({
                appId: props.appId,
                dataUniqueId: chartUniqueId + "_create_member",
                orgId: getOrgId(props),
                payload
            })
        } else {
            const merge = (sampleobj, validate) => {
                return { ...sampleobj, ...validate };
            }
            let ss = merge(sampleobj, props.validate)
            props.validator({ ...ss })
        }
    }

	const handleCancel = () => {
		history.goBack()
	}

    const handleEnabaleDisableUserClick = (url) => {
        props.terminateMember({
            appId: props.appId,
            dataUniqueId: chartUniqueId + "_terminate_member",
            orgId: props.user.orgId,
            id: props.fianlFormData?._id,
            dataLink: url
            // payload: {id:props.fianlFormData?._id,appId:props.appid}
        })
    }
    const handleOnSelectHandler = (data, type) => {
        setState({ ...state, [type]: data })
        props.handlesSaveFunctionality({ ...state, [type]: data })
    }

    const isLoading = () => {
        return props.formData?.[chartUniqueId + "_create_member_loading"]
    }
    const isTerminateLoading = () => {
        return props.formData?.[chartUniqueId + "_terminate_member_loading"]
    }

    return (
     <Grid style={{width: '100%', height:'calc(100vh - 200px)', overflow:'auto'}}>
        {!isNewV1Theme ? (
        <Grid>
            <Grid container xs={6} spacing={3}>
                <Grid item xs={3} sm={3} className={classes.label}>
                    <InputLabel htmlFor="my-input">Email</InputLabel>
                </Grid>
                <Grid item xs={9} sm={9}>
                    {
                        !props.fianlFormData?._id ?
                            <TextField
                                variant="outlined"
                                className={classes.TextField}
                                placeholder={'Enter Email id'}
                                onChange={handlesFormInputs}
                                name='email'
                                value={state.email}
                                error={props.validate.email ? true : false}
                                id="standard-error-helper-text"
                                helperText={props.validate.email ? 'Email is required' : ''}
                            />
                            :
                            <div>{state.email}</div>

					}
				</Grid>


				<Grid item xs={3} sm={3} className={classes.label}>
					<InputLabel htmlFor="my-input" className={classes.InputLabel}>First Name</InputLabel>
				</Grid>
				<Grid item xs={9} sm={9}>
					<TextField
						variant="outlined"
						className={classes.TextField}
						placeholder={'Enter First Name'}
						onChange={handlesFormInputs}
						name={'firstName'}
						value={state.firstName}
						error={props.validate.firstName ? true : false}
						id="standard-error-helper-text"
						helperText={props.validate.firstName ? 'First Name is required' : ''}
					/>
				</Grid>

				<Grid item xs={3} sm={3} className={classes.label}>
					<InputLabel htmlFor="my-input">Last Name</InputLabel>
				</Grid>
				<Grid item xs={9} sm={9}>
					<TextField
						variant="outlined"
						className={classes.TextField}
						placeholder={'Enter Last Name'}
						onChange={handlesFormInputs}
						name={'lastName'}
						value={state.lastName}
						error={props.validate.lastName ? true : false}
						id="standard-error-helper-text"
						helperText={props.validate.lastName ? 'Last Name is required' : ''}
					/>
				</Grid>

				{/* <Grid item xs={3} sm={3}>
                    <InputLabel htmlFor="my-input">Contact</InputLabel>
                </Grid>
                <Grid item xs={9} sm={9}>
                    <TextField 
                        variant="outlined" 
                        className={classes.TextField} 
                        placeholder={'Enter Contact'}
                        onChange={handlesFormInputs} 
                        name={'phone'}
                        value={state.phone}

                        error={props.validate.phone?true:false}
                        id="standard-error-helper-text"
                        helperText={props.validate.phone?'Contact is required':''} 
                    />
                </Grid> */}

				{/* <Grid item xs={12} sm={12}>
                    <InputLabel htmlFor="my-input">Status</InputLabel>
                    <RadioGroup aria-label="status" name="status" value={state.status} onChange={handlesFormInputs} className={classes.status}>
                        <FormControlLabel value="Active" control={<Radio />} label="Active" />
                        <FormControlLabel value="In Active" control={<Radio />} label="In Active" />
                        <FormControlLabel value="Suspended" control={<Radio />} label="Suspended" />
                        <FormControlLabel value="Terminated" control={<Radio />} label="Terminated" />
                    </RadioGroup>
                </Grid> */}
                {/* <Grid container xs={6} spacing={3} className={classes.gridContainer}> */}
                <Grid item xs={3} sm={3} className={classes.label}>
                    <InputLabel htmlFor="my-input">Select user roles</InputLabel>
                </Grid>
                <Grid item xs={9} sm={9}>
                    <ChipSelect
                        className={classes.chipSelect}
                        id='role'
                        onChange={(val) => handleOnSelectHandler(val, 'roles')}
                        value={props.fianlFormData?.roles}
                        isSearchable={true}
                        isMulti
                        textFieldProps={{
                            InputLabelProps: {
                                shrink: true,
                            },
                            variant: 'outlined',
                        }}
                        variant="fixed"
                        required
                        options={props.membersRoles}
                    />
                </Grid>
                <Grid item xs={3} sm={3} className={classes.label} >
                    <InputLabel htmlFor="my-input">Select Groups</InputLabel>
                </Grid>
                <Grid item xs={9} sm={9}>
                    <ChipSelect
                        id='group'
                        className={classes.chipSelect}
                        onChange={(val) => handleOnSelectHandler(val, 'groups')}
                        value={props.fianlFormData?.groups}
                        isSearchable={true}
                        isMulti
                        textFieldProps={{
                            InputLabelProps: {
                                shrink: true,
                            },
                            variant: 'outlined',
                        }}
                        variant="fixed"
                        options={props.membersGroup}
                    />
                </Grid>
                <Grid item xs={3} sm={3} className={classes.label} >
                    <InputLabel htmlFor="my-input" className={classes.InputLabel}>Select Supervisor</InputLabel>
                </Grid>
                <Grid item xs={9} sm={9}>
                    <ChipSelect
                        id='supervisor'
                        className={classes.chipSelect}
                        onChange={(val) => handleOnSelectHandler(val, 'supervisor')}
                        value={props.fianlFormData?.supervisor}
                        isSearchable={true}
                        textFieldProps={{
                            InputLabelProps: {
                                shrink: true,
                            },
                            variant: 'outlined',
                        }}
                        variant="fixed"
                        options={props.membersList.filter((mem) => mem?.id !== props.fianlFormData._id)}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    {
                        userHasAbility
                            ? props.fianlFormData?._id
                                ? <Can I={EDIT} a="Resource" ability={ability}>
                                    <Button style={{ float: 'right' }}
                                        variant="contained"
                                        color="primary"
                                        onClick={handlesFinalSubmit}
                                    >
                                        {isLoading() ?
                                            <CircularProgress style={{ color: '#ffff', }} size={24} /> :
                                            ("Update")
                                        }
                                    </Button>
                                </Can>
                                : <Can I={CREATE} a="Resource" ability={ability}>
                                    <Button style={{ float: 'right' }}
                                        variant="contained"
                                        color="primary"
                                        onClick={handlesFinalSubmit}
                                    >
                                        {isLoading() ?
                                            <CircularProgress style={{ color: '#ffff', }} size={24} /> :
                                            ("Save")
                                        }
                                    </Button>
                                </Can>
                            : null
                    }

                    {props.fianlFormData?._id &&
                        <>
                            <Button style={{ float: 'right', marginRight: 10 }}
                                variant="contained" color="secondary"
                                onClick={handleCancel}
                            >
                                {'Cancel'}
                            </Button>
                            <Button
                                style={{
                                    float: 'right',
                                    marginRight: 10
                                }}
                                variant="contained"
                                color="secondary"
                                onClick={() => handleEnabaleDisableUserClick(props.fianlFormData && props.fianlFormData.isDisable ? 'enable' : 'disable')}>
                                {isTerminateLoading() ? <CircularProgress style={{ color: '#ffff', }} size={24} /> : (props.fianlFormData?.isDisable ? 'Activate' : 'Terminate')}
                            </Button>
                        </>
                    }
                </Grid>
            </Grid>
        </Grid>
        ) : (
          <div className={classes.gridContainer}>
            <Grid container spacing={2} className={classes.containerDiv}>
              {/* Row 1 */}
            
              <Grid item xs={12} sm={6}>
                <InputLabel className={classes.lables}>First Name</InputLabel>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder="Enter First Name"
                  onChange={handlesFormInputs}
                  name="firstName"
                  value={state.firstName}
                  error={props.validate.firstName ? true : false}
                  helperText={props.validate.firstName ? 'First Name is required' : ''}
                  className={classes.textField}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <InputLabel className={classes.lables}>Last Name</InputLabel>
                <TextField
                  variant="outlined"
                  fullWidth
                  placeholder="Enter Last Name"
                  onChange={handlesFormInputs}
                  name="lastName"
                  value={state.lastName}
                  error={props.validate.lastName ? true : false}
                  helperText={props.validate.lastName ? 'Last Name is required' : ''}
                  className={classes.textField}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputLabel className={classes.lables}>Email</InputLabel>
                {!props.fianlFormData?._id ? (
                  <TextField
                    variant="outlined"
                    fullWidth
                    placeholder="Enter Email id"
                    onChange={handlesFormInputs}
                    name="email"
                    value={state.email}
                    error={props.validate.email ? true : false}
                    helperText={props.validate.email ? 'Email is required' : ''}
                    className={classes.textField}
                  />
                ) : (
                  <TextField
                    variant="outlined"
                    fullWidth
                    // placeholder="Enter Email id"
                    // onChange={handlesFormInputs}
                    name="email"
                    value={state.email}
                    InputProps={{
                    readOnly: true,
                    }}
                    // error={props.validate.email ? true : false}
                    // helperText={props.validate.email ? 'Email is required' : ''}
                    className={classes.readonlyTextField}
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputLabel className={classes.lables}>Select Supervisor</InputLabel>
                <ChipSelect
                  id="supervisor"
                  className={classes.chipSelect}
                  onChange={val => handleOnSelectHandler(val, 'supervisor')}
                  value={props.fianlFormData?.supervisor}
                  isSearchable
                  textFieldProps={{
                    InputLabelProps: { shrink: true },
                    variant: 'outlined',
                  }}
                  variant="outlined"
                  options={props.membersList.filter(mem => mem?.id !== props.fianlFormData._id)}
                />
              </Grid>
 
              <Grid item xs={12} sm={6}>
                <InputLabel className={classes.lables}>Select Role</InputLabel>
                <ChipSelect
                  id="role"
                  className={classes.chipSelect}
                  classNamePrefix="custom"
                  onChange={val => handleOnSelectHandler(val, 'roles')}
                  value={props.fianlFormData?.roles}
                  isSearchable
                  isMulti
                  textFieldProps={{
                    InputLabelProps: { shrink: true },
                    variant: 'outlined',
                  }}
                  variant="outlined"
                  required
                  options={props.membersRoles}
                />
              </Grid>

              {/* Row 2 */}
              <Grid item xs={12} sm={6}>
                <InputLabel className={classes.lables}>Select Group</InputLabel>
                <ChipSelect
                  id="group"
                  className={classes.chipSelect}
                  classNamePrefix="custom"
                  onChange={val => handleOnSelectHandler(val, 'groups')}
                  value={props.fianlFormData?.groups}
                  isSearchable
                  isMulti
                  textFieldProps={{
                    InputLabelProps: { shrink: true },
                    variant: 'outlined',
                  }}
                  variant="outlined"
                  options={props.membersGroup}
                />
              </Grid>

             <Grid item xs={12} sm={6}>
                <InputLabel className={classes.lables}>Status</InputLabel>
                <ChipSelect
                  id="status"
                  className={classes.chipSelect}
                  classNamePrefix="custom"
                  onChange={val => handleOnSelectHandler(val, 'status')}
                  value={props.fianlFormData?.status}
                  isSearchable
                  textFieldProps={{
                    InputLabelProps: { shrink: true },
                    variant: 'outlined',
                  }}
                  variant="outlined"
                  options={[
                    { label: 'Active', value: 'Active' },
                    { label: 'Inactive', value: 'Inactive' },
                  ]}
                />
              </Grid>
              {/* Empty space or additional field */}
              <Grid item xs={12} sm={6}>
                {' '}
              </Grid>
            </Grid>
            {/* Buttons */}
            <Grid
              item
              xs={12}
              className={classes.buttonContainer}
            >
              {props.fianlFormData?._id ? (
                <>
                  <Button
                    variant="contained"
                    className={classes.cancel}
                    onClick={handleCancel}
                  >
                    Close
                  </Button>
                  <Button
                    variant="contained"
                    className={classes.cancel}
                    onClick={() =>
                      handleEnabaleDisableUserClick(
                        props.fianlFormData.isDisable ? 'enable' : 'disable',
                      )
                    }
                  >
                    {isTerminateLoading() ? (
                      <CircularProgress style={{ color: '#fff' }} size={24} />
                    ) : props.fianlFormData.isDisable ? (
                      'Activate'
                    ) : (
                      'Terminate'
                    )}
                  </Button>
                  <Button
                    variant="contained"
                    className={classes.update}
                    onClick={handlesFinalSubmit}
                  >
                    {isLoading() ? (
                      <CircularProgress style={{ color: '#fff' }} size={24} />
                    ) : (
                      'Update'
                    )}
                  </Button>
                </>
              ) : (
                  <>
                   
                    <Button
                      variant="contained"
                      className={classes.cancel}
                      onClick={handleCancel}
                    >
                      Close
                    </Button>

                    {/* Save Button */}
                    <Button
                      variant="contained"
                      className={classes.update}
                      onClick={handlesFinalSubmit}
                    >
                      {isLoading() ? (
                        <CircularProgress style={{ color: '#fff' }} size={24} />
                      ) : (
                        'Save'
                      )}
                    </Button>
                  </>
                )}
            </Grid>
          </div>
        )}
      </Grid>
    );
}

export default BasicInfo